import { render, staticRenderFns } from "./portal_Product-info-textImageList.vue?vue&type=template&id=cfdb89f4&scoped=true&"
import script from "./portal_Product-info-textImageList.vue?vue&type=script&lang=js&"
export * from "./portal_Product-info-textImageList.vue?vue&type=script&lang=js&"
import style0 from "./portal_Product-info-textImageList.vue?vue&type=style&index=0&id=cfdb89f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdb89f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
